module.exports = __webpack_public_path__ + "static/media/firefox_logo_icon.1c9504f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/browser/firefox_logo_icon.svg
// module id = 1602
// module chunks = 0